import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ANONYMOUSAUTHENTICATIONPRELOADERBLOCK_LEGACY_FIELD_ORDER = [];

const {
  anonymousAuthenticationPreloaderBlockDescriptor: _generatedAnonymousAuthenticationPreloaderBlockDescriptor,
  anonymousAuthenticationPreloaderBlockBlocDefinition,
  anonymousAuthenticationPreloaderBlockDashboardLayout,
  anonymousAuthenticationPreloaderBlockConfig,
  anonymousAuthenticationPreloaderBlockResolveConfig,
  anonymousAuthenticationPreloaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Anonymous authentication preloader",
    componentType: 'AnonymousAuthenticationPreloaderBlockComponent',
    category: 'content',
    description: "Anonymous authentication preloader.",
    keywords: [],
    allowed_in: ["MainLayout", "KioskMainLayout"],
    allowedIn: [
      { bloc: 'MainLayoutComponent', slot: 'global_features' },
      { bloc: 'MainLayoutComponent', slot: 'footer' },
      { bloc: 'KioskMainLayoutComponent', slot: 'global_features' },
      { bloc: 'KioskMainLayoutComponent', slot: 'footer' },
    ],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function anonymousAuthenticationPreloaderBlockDescriptor(): IBlockDescriptor;
export function anonymousAuthenticationPreloaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function anonymousAuthenticationPreloaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedAnonymousAuthenticationPreloaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedAnonymousAuthenticationPreloaderBlockDescriptor, anonymousAuthenticationPreloaderBlockProperties, fieldOrder);
}

export {
  anonymousAuthenticationPreloaderBlockBlocDefinition,
  anonymousAuthenticationPreloaderBlockDashboardLayout,
  anonymousAuthenticationPreloaderBlockProperties,
  anonymousAuthenticationPreloaderBlockConfig,
  anonymousAuthenticationPreloaderBlockResolveConfig,
};

export type AnonymousAuthenticationPreloaderBlockConfig = typeof anonymousAuthenticationPreloaderBlockConfig;
